import React, { createContext, useState, ReactNode } from 'react';
import { useContext } from 'react';

interface PrivacyPolicyContextType {
  showPrivacyPolicy: boolean;
  showPolicy: () => void;
  hidePolicy: () => void;
}

const PrivacyPolicyContext = createContext<PrivacyPolicyContextType | undefined>(undefined);

export const PrivacyPolicyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const showPolicy = () => setShowPrivacyPolicy(true);
  const hidePolicy = () => setShowPrivacyPolicy(false);

  return (
    <PrivacyPolicyContext.Provider value={{ showPrivacyPolicy, showPolicy, hidePolicy }}>
      {children}
    </PrivacyPolicyContext.Provider>
  );
};

export const usePrivacyPolicy = () => {
  const context = useContext(PrivacyPolicyContext);
  if (!context) {
    throw new Error('usePrivacyPolicy must be used within a PrivacyPolicyProvider');
  }
  return context;
};

